import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { IndikatorenService } from '../../../indikatoren/services/indikatoren.service';
import { Indikator } from '../../../indikatoren/interfaces/indikatoren.interface';

export interface AddIndicatorData {
  roomId: string;
  standortId: string;
}

@Component({
  selector: 'app-add-indicator-dialog',
  templateUrl: './add-indicator-dialog.component.html',
  styleUrls: ['./add-indicator-dialog.component.css'],
})
export class AddIndicatorDialogComponent implements OnInit {
  frmIndicator: UntypedFormGroup;
  roomId: string;
  standortId: string;
  indikatoren: Indikator[] = [];
  loading = false;
  selectedIndikator: Indikator | null = null;

  constructor(
    public dialogRef: MatDialogRef<AddIndicatorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddIndicatorData,
    private _fb: UntypedFormBuilder,
    private indikatorenService: IndikatorenService
  ) {
    this.roomId = data.roomId;
    this.standortId = data.standortId;

    this.frmIndicator = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      indikator_id: ['', [Validators.required]],
      schwellenwert: ['', [Validators.required]],
      einheit: ['', [Validators.required]],
      anzahl: [1, [Validators.required, Validators.min(1), Validators.max(100)]],
      room_id: [this.roomId],
      standort_id: [this.standortId]
    });
  }

  ngOnInit() {
    this.loadActiveIndikatoren();
  }

  loadActiveIndikatoren() {
    this.loading = true;
    this.indikatorenService.getIndikatoren(1, 100, '', 'status_id', 'desc').subscribe({
      next: (response) => {
        // Filter only active indikatoren (status_id = 1)
        this.indikatoren = (response.data || []).filter((indikator: Indikator) => indikator.status_id === 1);
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading indikatoren:', error);
        this.loading = false;
      }
    });
  }

  onIndikatorSelected() {
    const selectedId = this.frmIndicator.get('indikator_id')?.value;
    
    if (selectedId) {
      // Convert selectedId to number for comparison
      const numericSelectedId = parseInt(selectedId, 10);
      this.selectedIndikator = this.indikatoren.find(ind => ind.id === numericSelectedId) || null;
      
      if (this.selectedIndikator) {
        // Copy schwellenwert, einheit, and name from the selected indikator
        const schwellenwert = this.selectedIndikator.schwellenwert || 'Standard';
        const einheit = this.selectedIndikator.einheit || '°C';
        const name = this.selectedIndikator.code || '';
        
        this.frmIndicator.patchValue({
          name: name,
          schwellenwert: schwellenwert,
          einheit: einheit
        });
      }
    } else {
      this.selectedIndikator = null;
    }
  }

  onConfirm(): void {
    if (this.frmIndicator.valid) {
      this.dialogRef.close({ 
        event: 'create', 
        data: this.frmIndicator.value 
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}
